import { DESCRIPTION_SPACE, VALUE_SEPARATOR } from './separators';
import type { DescriptionValue } from './types';

/** Значения части одной строкой — так они и стоят в описании отбора */
export const joinValuesText = (values: DescriptionValue[]): string =>
  values.map((value) => value.text).join(`${VALUE_SEPARATOR}${DESCRIPTION_SPACE}`);
